import { RequestConfig } from '~/common/services/requests';
import { Category, CategoryQuery } from '../../../types';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { CATEGORIES_BASE_PATH } from '../constants/categoriesBasePath';

export const selectCategories = async (
  constructPost: ConstructPost,
  query: CategoryQuery,
  config?: RequestConfig,
): Promise<NonPaginatedResponse<Category[]> | undefined> =>
  constructPost<NonPaginatedResponse<Category[]>>(
    `${CATEGORIES_BASE_PATH}/select`,
    { data: query, ...config },
  );
